var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.1898H3.5C2.949 15.1898 2.5 14.7134 2.5 14.1265V3.75941L9.9 9.66067C10.078 9.80315 10.289 9.87333 10.5 9.87333C10.711 9.87333 10.922 9.80315 11.1 9.66067L18.5 3.75941V14.1265C18.5 14.7134 18.051 15.1898 17.5 15.1898ZM16.833 2.43029L10.5 7.48092L4.167 2.43029H16.833ZM17.5 0.303711H3.5C1.846 0.303711 0.5 1.7349 0.5 3.49358V14.1265C0.5 15.8852 1.846 17.3164 3.5 17.3164H17.5C19.154 17.3164 20.5 15.8852 20.5 14.1265V3.49358C20.5 1.7349 19.154 0.303711 17.5 0.303711Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.032a75df6d8c0ba5719b22b8c75cb8f7.svg";
export { ForwardRef as ReactComponent };